import { useState } from "react";
import BirdseyModal from "./BirdseyModal";
import { trackButtonClick } from "@/utils/analytics";

const BirdseyBanner = ({ bannerDetails, propertyId, bannerType }) => {
  const [showBanner, setShowBanner] = useState(false);

  const handleRedirection = () => {
    trackButtonClick({
      eventName: "banner_click",
      eventCategory: "NEW-PDP",
      eventSource: "on banner click",
      eventLabel: `Banner Name : ${bannerType === "CRYPTO" ? "Crypto" : "Birdseye"} banner`,
    });

    if (bannerDetails.name === "BIRDSEY") {
      setShowBanner(true);
    } else {
      window.open(bannerDetails?.linkURL, "_blank");
    }
  };

  return (
    <div className="pl0" tabIndex="0">
      <img className="img-whp w-100 cover cursor-pointer" onClick={handleRedirection} src={bannerDetails?.imgURL} alt="Like This Property? Buy it with your Crypto Banner" />
      <BirdseyModal showBanner={showBanner} setShowBanner={setShowBanner} propertyId={propertyId} />
    </div>
  );
};
export default BirdseyBanner;